class OrganizationHelper {
  isFop(edrpou: string): boolean {
    return !!edrpou && edrpou.trim().length === 10;
  }
}

export const organizationHelper = new OrganizationHelper();
